import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=6c6c2ff4&scoped=true"
import script from "./category-list.vue?vue&type=script&lang=js"
export * from "./category-list.vue?vue&type=script&lang=js"
import style0 from "./category-list.vue?vue&type=style&index=0&id=6c6c2ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c2ff4",
  null
  
)

export default component.exports